var exports = {
  "YJ": "Group__9NO40t",
  "fI": "Row__H27PZr",
  "Ip": "LoadingIndicator__aZuVhO",
  "bd": "inputRow__KgOlSC",
  "W2": "recommended__WgpVhQ",
  "hV": "NumberBadge__ZS_4is",
  "Sc": "Checkbox__cgzV8p",
  "xY": "checkboxChecked__9on_wr",
  "EY": "Text__aHmj3w",
  "hE": "Title__dz5mA4",
  "VY": "Description__jqVcoy",
  "Uh": "KeybindingHint__VaJNJi",
  "$e": "rowWithSlot__kxJIll",
  "$s": "OverlayButton__crj4LW",
  "C8": "RowContent__0eP7Sr",
  "hc": "OptionsSlot__lzG_MW",
  "ue": "Kbd__i49rGS",
  "pd": "Input__4msFk_",
};

module.exports = exports;
